import {Link} from 'react-router-dom';
import Api from '../services/api';
import {useText} from './Text';
export default function SafeLink({onClick,...props}) {
  const {t}=useText();
  return <Link {...props} onClick={event=>{onClick?.(event);if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;if(Api.hasUnsavedChanges?.()&&!window.confirm(t('Kaydedilmemiş değişiklikleriniz var. Bu sayfadan ayrılmak istiyor musunuz?')))event.preventDefault();}}/>;
}
